// SEQ-199: the plain-words error shown under one grid settings field, or null when the
// value is fine. Pure, so the rules are tested and the drawer only renders them.
// Sentences start with a capital and say how to fix it (standard 6.1, form validation).

import { GRID_MAX_TOP_N } from "../../lib/pnl/pnlGridConfig.ts";

/** True for a validator message about a grid setting ("grid.topN must ..." or "each grid.paretoBands entry ..."), which the drawer explains under the field instead of printing the path. */
export function isGridFieldError(error: string): boolean {
  return /^(each )?grid\./.test(error);
}

/** A Pareto cut-off, a percent of the total from 0 to 100. NaN is what an emptied number box holds. */
export function cutoffError(value: number): string | null {
  return Number.isFinite(value) && value >= 0 && value <= 100 ? null : "Enter a cut-off from 0 to 100.";
}

/** A band, cut-off or rest label: 1 to 40 characters. */
export function labelError(label: string): string | null {
  if (label.trim() === "") return "Give this a label.";
  if (label.length > 40) return "Use 40 characters or fewer.";
  return null;
}

/** The "Show the top" box as typed. Empty is fine (every project is shown). */
export function topNError(raw: string): string | null {
  const MAX = GRID_MAX_TOP_N;
  if (raw.trim() === "") return null;
  const n = Number(raw);
  return Number.isInteger(n) && n >= 1 && n <= MAX ? null : `Enter a whole number from 1 to ${MAX}, or leave it empty to show every project.`;
}
